/**
 * AP-31 Nachtrag — **Telefonnummern in einer Schreibweise:** `+43 664 1234562`.
 *
 * Landesvorwahl, Ortsnetz- bzw. Mobilvorwahl, Rufnummer — getrennt durch je ein
 * Leerzeichen. Die Grenze zwischen Vorwahl und Rufnummer lässt sich nicht aus
 * der Ziffernzahl raten (Wien `1`, Linz `732`, Mödling `2236`, mobil `664`),
 * deshalb der Nummernplan aus `libphonenumber-js`.
 *
 * Formatiert wird **beim Verlassen des Feldes**, nicht bei jedem Tastendruck —
 * sonst springt der Cursor, während jemand tippt.
 *
 * Was sich nicht als Nummer lesen lässt, bleibt **unverändert** stehen: Eine
 * Formatierung, die „Zentrale, ab 8 Uhr" löscht, wäre schlimmer als keine.
 */

import { parsePhoneNumberFromString, type CountryCode } from 'libphonenumber-js/min'

/**
 * @param land Ländercode für Nummern ohne Landesvorwahl („0664 …") — die
 *   Adresse des Partners, sonst Österreich.
 */
export function formatiereTelefon(eingabe: string, land = 'AT'): string {
  const roh = eingabe.trim()
  if (!roh) return ''
  // „0043 664 …" ist dieselbe Nummer wie „+43 664 …".
  const normiert = roh.replace(/^00(?=[1-9])/, '+')
  const nummer = parsePhoneNumberFromString(normiert, land.toUpperCase() as CountryCode)
  if (!nummer || !nummer.isPossible()) return roh
  return nummer.formatInternational()
}
